import script from "./InvitationListView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationListView.vue?vue&type=script&setup=true&lang=js"

import "./InvitationListView.vue?vue&type=style&index=0&id=13acd55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13acd55c"]])

export default __exports__